import AssetLoanApprovalTable from "./ApprovalTable";

const CompanyAssetLoanApproval = () => <AssetLoanApprovalTable level="company" />;

export default CompanyAssetLoanApproval;
